
<app-cx-interaction-form class="tw-h-full tw-overflow-y-scroll" (cxDrawerClose)="sideNavClose()" [formSaving]="formSaving" [tagOptions]="tagOptions" (saveCxInteraction)="onSaveCxInteraction($event)"></app-cx-interaction-form>
